import React from 'react';

/**
 * FoxSpinner - Spinner padrão do Fox Seller
 * 
 * @param {string} size - 'sm', 'md', 'lg', 'xl' (default: 'md')
 * @param {string} text - Texto opcional abaixo do spinner
 * @param {boolean} fullscreen - Se deve ocupar a tela toda com overlay
 */
export const FoxSpinner = ({ size = 'md', text = '', fullscreen = false }) => {
  const sizes = {
    sm: { icon: 'w-8 h-8', ring: 'w-12 h-12 border-2', text: 'text-sm' },
    md: { icon: 'w-12 h-12', ring: 'w-16 h-16 border-3', text: 'text-base' },
    lg: { icon: 'w-16 h-16', ring: 'w-24 h-24 border-4', text: 'text-lg' },
    xl: { icon: 'w-24 h-24', ring: 'w-32 h-32 border-4', text: 'text-xl' }
  };

  const s = sizes[size] || sizes.md;

  const spinner = (
    <div className="flex flex-col items-center gap-4">
      <div className="relative flex items-center justify-center">
        <img 
          src="https://customer-assets.emergentagent.com/job_8f198eda-3cd9-45f6-a741-5b80db2d25c7/artifacts/wkn4ynag_incone.png"
          alt="Carregando"
          className={`${s.icon} animate-pulse`}
        />
        <div className={`absolute ${s.ring} border-orange-500 border-t-transparent rounded-full animate-spin`}></div>
      </div>
      {text && (
        <p className={`text-white ${s.text} font-semibold animate-pulse`}>
          {text}
        </p>
      )}
    </div>
  );

  if (fullscreen) {
    return (
      <div className="fixed inset-0 bg-black/70 backdrop-blur-sm flex items-center justify-center z-[100]">
        {spinner}
      </div>
    );
  }

  return spinner;
};

/**
 * FoxSpinnerInline - Versão inline (sem fundo) para usar dentro de containers
 */
export const FoxSpinnerInline = ({ size = 'md' }) => {
  const sizes = {
    sm: { icon: 'w-6 h-6', ring: 'w-10 h-10 border-2' },
    md: { icon: 'w-10 h-10', ring: 'w-14 h-14 border-3' },
    lg: { icon: 'w-12 h-12', ring: 'w-20 h-20 border-4' }
  };

  const s = sizes[size] || sizes.md;

  return (
    <div className="flex justify-center p-4">
      <div className="relative flex items-center justify-center">
        <img 
          src="https://customer-assets.emergentagent.com/job_8f198eda-3cd9-45f6-a741-5b80db2d25c7/artifacts/wkn4ynag_incone.png"
          alt="Carregando"
          className={`${s.icon} animate-pulse`}
        />
        <div className={`absolute ${s.ring} border-orange-500 border-t-transparent rounded-full animate-spin`}></div>
      </div>
    </div>
  );
};

export default FoxSpinner;
